let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6CUDZ")).then(() => parcelRequire('ixD6r'));